// extracted by mini-css-extract-plugin
export default {"heading":"Wi-z","list":"Xi-z"};